export default __webpack_public_path__ + "static/media/Ies_MesasCruzadas_Dario_ACCESO_eng.c8e37a27.jpg";